import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BasicService } from '../../providers/basic';
import { environment as config } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { AuthHttp } from 'angular2-jwt';
import { AuthService } from '../auth/auth.service';
import { ISession } from '../../models/session';
import { IEmailContent } from '../../models/emailContent';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class OndemandEmailService extends BasicService {
  private API = config.emailsv3.url;

  constructor(
    protected authService: AuthService,
    protected translate: TranslateService,
    private http: AuthHttp,
  ) {
    super(authService, translate);
  }

  public getEmailContent(session: ISession, notify: boolean = false): Observable<IEmailContent> {
    return this.http
      .get(`${this.API}/sessions/${session.id}/ondemand_content?language=${session.language}`)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public saveEmailContent(session: ISession, content: IEmailContent, notify: boolean = true): Observable<IEmailContent> {
    return this.http
      .put(`${this.API}/sessions/${session.id}/ondemand_content?language=${session.language}`, content)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public previewEmailContent(session: ISession, notify: boolean = false): Observable<{ content: string }> {
    return this.http
      .get(`${this.API}/sessions/${session.id}/ondemand_content/preview?language=${session.language}`)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/ondemand-email.service.ts